
import { getAuthToken } from "../utils/commonHelper";
import axiosInstance from "../utils/AxiosInstance";

const API_URL = `${process.env.REACT_APP_API_URL}`; // Replace with your actual API URL



// Fetch CMS by type (privacy_policy or terms_and_conditions)
export const fetchCmsByTypeQuery = async (type: 'privacy_policy' | 'terms_and_conditions', lan: string) => {
  const customHeaders = {
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${getAuthToken()}`
  };
  const response = await axiosInstance.get(`${API_URL}/${lan}/cms/${type}`, { headers: customHeaders });
  return response.data;
};

// Create a new CMS entry
export const addCmsQuery = async (newCms: { type: 'privacy_policy' | 'terms_and_conditions'; content: string; lan: string; }) => {
  const customHeaders = {
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${getAuthToken()}`
  };
  const { lan, ...rest } = newCms
  const response = await axiosInstance.post(`${API_URL}/${lan}/cms`, rest, { headers: customHeaders });
  return response.data;
};

// Update an existing CMS entry
export const updateCmsQuery = async (
  type: 'privacy_policy' | 'terms_and_conditions',
  updatedCms: { content: string },
  lan: string
) => {
  const customHeaders = {
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${getAuthToken()}`
  };
  const response = await axiosInstance.put(`${API_URL}/${lan}/cms/${type}`, updatedCms, { headers: customHeaders });
  return response.data;
};
